import { NextPage } from 'next';
import Bienvenue from 'src/apps/Onboarding/Bienvenue';
import {
  getSharedServerSideProps,
  SharedServerSideProps,
} from 'src/utils/getSharedServerSideProps';
import { LocaleOverride } from 'src/components/LocaleOverride';

export const getServerSideProps = getSharedServerSideProps;

const Page: NextPage<SharedServerSideProps> = ({ locale, messages, ...rest }) => {
  return (
    <LocaleOverride locale={locale} messages={messages}>
      <Bienvenue {...rest} />
    </LocaleOverride>
  );
};

export default Page;
